import React from 'react';

const Mens = () => (
	<svg viewBox="0 0 100 100" className="af-icon">
		<path className="mens" d="M50,41.2c-6.2,0-11.2-5-11.2-11.2s5-11.2,11.2-11.2s11.2,5,11.2,11.2S56.2,41.2,50,41.2z M50,21.2 c-4.8,0-8.8,3.9-8.8,8.8s3.9,8.8,8.8,8.8s8.8-3.9,8.8-8.8S54.8,21.2,50,21.2z M28.8,43.8v37.5h42.5V43.8H28.8z M68.8,78.8h-7.5V60 h-2.5v18.8H41.2V60h-2.5v18.8h-7.5V46.2h37.5V78.8z"/>
	</svg>
);

export default Mens;
